<script setup>
</script>

<template>
   <div class="cg-column-content gap-2">

      <div class="card cg-data-card">
         <div class="card-body">

            <div class="cg-data-wrapper">

               <div class="d-flex flex-column gap-2 align-items-center align-items-xl-start">
                  <div class="cg-data-content">
                     <slot name="number"></slot>
                  </div>

                  <div class="cg-data-name">
                     <slot name="name"></slot>
                  </div>
               </div>

               <div class="cg-data-icon d-none d-xl-block">
                  <slot name="icon"></slot>
               </div>
            </div>
         </div>
      </div>

   </div>
</template>